import type { DepartmentFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: DepartmentFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.name,
    icon: "fas fa-home",
    iconBackground: item.color || undefined,
  };
};

const toOption = (item: DepartmentFragment): IOption => {
  return {
    value: item.id,
    title: item.name,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
